if (!customElements.get('rotating-review-spotlight')) {
  class RotatingReviewSpotlight extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.rrs__slide'));
      this.dots = Array.from(this.querySelectorAll('.rrs__dot'));
      if (this.slides.length < 2) return;
      this.currentIndex = Math.max(
        0,
        this.slides.findIndex((slide) => slide.classList.contains('is-active'))
      );

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.go(index));
      });

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (this.dataset.autoplay === 'true' && !this.reducedMotion.matches) {
        this.visibilityObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.play();
              } else {
                this.pause();
              }
            });
          },
          { threshold: 0.1 }
        );
        this.visibilityObserver.observe(this);
      }
    }

    disconnectedCallback() {
      this.visibilityObserver?.disconnect();
    }

    go(index) {
      if (index === this.currentIndex) return;
      const outgoing = this.slides[this.currentIndex];
      const incoming = this.slides[index];

      outgoing.classList.remove('is-active');
      outgoing.classList.add('is-leaving');
      outgoing.setAttribute('aria-hidden', 'true');
      this.dots[this.currentIndex] && this.dots[this.currentIndex].classList.remove('is-active');

      incoming.classList.add('is-active');
      incoming.removeAttribute('aria-hidden');
      this.dots[index] && this.dots[index].classList.add('is-active');

      clearTimeout(outgoing._rrsResetTimeout);
      outgoing._rrsResetTimeout = setTimeout(() => {
        outgoing.style.transition = 'none';
        outgoing.classList.remove('is-leaving');
        void outgoing.offsetHeight;
        outgoing.style.transition = '';
      }, 480);

      this.currentIndex = index;
    }

    next() {
      this.go((this.currentIndex + 1) % this.slides.length);
    }

    play() {
      clearInterval(this.autoplay);
      const speed = (parseFloat(this.dataset.speed) || 6) * 1000;
      this.autoplay = setInterval(() => this.next(), speed);
    }

    pause() {
      clearInterval(this.autoplay);
      this.autoplay = null;
    }
  }

  customElements.define('rotating-review-spotlight', RotatingReviewSpotlight);
}
